// extracted by mini-css-extract-plugin
module.exports = {"agreementHeader":"styles_agreementHeader__1UGGg","agreementContent":"styles_agreementContent__3beAc"};